import script from "./silderItem.vue?vue&type=script&setup=true&lang=js"
export * from "./silderItem.vue?vue&type=script&setup=true&lang=js"

import "./silderItem.vue?vue&type=style&index=0&id=6406e399&lang=postcss"

const __exports__ = script;

export default __exports__